import { useTranslation } from 'react-i18next'
import {
  Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle,
} from '@mui/material'
import { useAppStore } from '@/store/appStore'

/**
 * Mounted once, app-wide. Any navigation or filter change routed through `requestGuardedAction`
 * lands here when the note editor holds unsaved text, so the user decides rather than losing it.
 */
export function UnsavedNotesDialog() {
  const { t } = useTranslation()
  const pending = useAppStore((s) => s.pendingGuardedAction)
  const resolve = useAppStore((s) => s.resolveGuardedAction)

  return (
    <Dialog open={pending !== null} onClose={() => resolve(false)} maxWidth="xs" fullWidth>
      <DialogTitle>{t('notes.unsavedNavTitle')}</DialogTitle>
      <DialogContent>
        <DialogContentText>{t('notes.unsavedNavMessage')}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => resolve(false)} autoFocus>{t('notes.keepEditing')}</Button>
        <Button onClick={() => resolve(true)} color="error">{t('notes.unsavedNavDiscard')}</Button>
      </DialogActions>
    </Dialog>
  )
}
